import PatcraftApi from "../../../scripts/patcraft-api";
import { BASKET_SITEITEMS } from "../../../constants/checkout-constant";

// State
const state = () => ({
    basket: {},
    loader: false,
    saveForLater: {
        ProjectItems: [],
        SiteItems: []
    },
    checkoutTypeProceed: "",
    fullTypeSizeSamples: [],
    ideaBookFlag: false,
    MaxCartLimit: {},
});

// Getters
const getters = {
    getBasketItems: state => {
        const baskitItems = {...state.basket}
        const modifyBasketItems = (array) => {
            array && array.forEach((item, index) => {
                let isFullSize = state.fullTypeSizeSamples.find(({ Key, Value }) => Key === item.VehicleId && Value === true);
                let checkVehicleId = item.SampleSizes.find(({ Value }) => Value == item.VehicleId);
                if (!checkVehicleId) {
                    array[index].VehicleId = "";
                }
                if (isFullSize && !state.basket.IsTrustedUser) {
                    if(array[index].SampleAvailability > state.MaxCartLimit.maxfullsizeitems) {
                        array[index].SampleAvailability = state.MaxCartLimit.maxfullsizeitems;
                    }
                }
            });
            return array
        } 
        if(baskitItems.SiteItems) {
            baskitItems.SiteItems = modifyBasketItems(baskitItems.SiteItems) ?? [];
        }
        if(baskitItems.ProjectItems) {
            baskitItems.ProjectItems = modifyBasketItems(baskitItems.ProjectItems) ?? [];
        }        
        return baskitItems;
    },
    getSaveForLater: state => {
        return state.saveForLater;
    },
    getSaveForLaterCount: state => {
        return {
            siteItems: (state.saveForLater && state.saveForLater.SiteItems) ? state.saveForLater.SiteItems.reduce((accumulator, currentValue) => accumulator + currentValue.Quantity, 0) : 0,
            projectItems: (state.saveForLater && state.saveForLater.ProjectItems) ? state.saveForLater.ProjectItems.reduce((accumulator, currentValue) => accumulator + currentValue.Quantity, 0) : 0,
        };
    },
    getLoader: state => {
        return state.loader
    },
    getBasketCount: state => {
        return {
            siteItems: (state.basket && state.basket.SiteItems) ? state.basket.SiteItems.reduce((accumulator, currentValue) => accumulator + currentValue.Quantity, 0) : 0,
            projectItems: (state.basket && state.basket.ProjectItems) ? state.basket.ProjectItems.reduce((accumulator, currentValue) => accumulator + currentValue.Quantity, 0) : 0,
            trayItems: (state.basket && state.basket.TrayItems) ? state.basket.TrayItems.reduce((accumulator, currentValue) => accumulator + currentValue.Quantity, 0) : 0
        };
    },
    getCheckoutTypeProceed: state => {
        return state.checkoutTypeProceed
    },
    getFullTypeSizeSamples: state => {
        return state.fullTypeSizeSamples;
    },
    getIdeaBookFlag: state => {
        return state.ideaBookFlag;
    },
    getQuantityValidation: state => {
        if (state.basket) {
            if(state.basket.SiteItems) {
                let isSite = state.basket.SiteItems.some(e => e.Quantity > e.SampleAvailability);
                if(isSite) return true
            } 
            if(state.basket.ProjectItems) {
                let isProj = state.basket.ProjectItems.some(e => e.Quantity > e.SampleAvailability);
                if(isProj) return true
            }
        }
        return false;
    },
    getQuantityValidationForSameSamples: state => {
        let obj = {
            isError: false,
            SellingStyleNumber: '',
            SellingColorNumber: ''
        }
        if (state.basket) {
            if(state.basket.SiteItems.length > 0 && state.basket.ProjectItems.length > 0) {
                const isProj = state.basket.SiteItems.some((s) => {            
                    return state.basket.ProjectItems.some(p => {
                        const isValid = s.Item && p.Item && (s.Item.SellingStyleNumber === p.Item.SellingStyleNumber) && (s.Item.SellingColorNumber === p.Item.SellingColorNumber) && (s.VehicleId === p.VehicleId)
                        if(isValid && ((s.Quantity + p.Quantity) > s.SampleAvailability)) {
                            obj.SellingStyleNumber = s.Item.SellingStyleNumber;
                            obj.SellingColorNumber = s.Item.SellingColorNumber;
                            obj.isError = true;
                            return true
                        }
                    })                    
                });
                if(isProj) return obj
            }
        }
        return obj;
    },
    getSampleSizeValidation: state => {
        if (state.basket && state.basket.SiteItems) {
           let isSite = state.basket.SiteItems.find( e => e.SampleSizes.length === 0 || !e.VehicleId);
           if (isSite) return true;
        }
        if (state.basket && state.basket.ProjectItems) {
            let isProj = state.basket.ProjectItems.find(e => e.SampleSizes.length === 0 || !e.VehicleId);
            if (isProj) return true;
        }
        if (state.basket && state.basket.TrayItems) {
           let isTray = state.basket.TrayItems.find(e => e.SampleSizes.length === 0 || !e.VehicleId);
           if (isTray) return true;
        }
        return false;
    },
    getMaxCartLimit: (state) => {
        return state.MaxCartLimit;
    }

};

// Mutations
const mutations = {
    setBasketItem(state, data) {
        const results = { ...data }
        const updateItems = (array) => {
            array && array.forEach((element, index) => {
                let vehicleId = element.VehicleId;
                let selectedSize = element["SampleSizes"].find(({ Value }) => Value === vehicleId);
                if (element.VehicleId === results.LatestIdeaBook.IdeabookVehicleId && element.IsIdeaBook) {
                    this._vm.$cookies.set("ideaBook", true, "1m");
                    state.ideaBookFlag = true;
                 }
                if (selectedSize) {
                    array[index]["isVehicleIdMatch"] = true;
                } else {
                    array[index]["isVehicleIdMatch"] = false;
                }
            });
            return array
        }
        results.SiteItems = updateItems(results.SiteItems,);
        results.ProjectItems = updateItems(results.ProjectItems);
        state.basket = results;

        let totalSiteItems = state.basket && state.basket.SiteItems
            ? state.basket.SiteItems.reduce((accumulator, currentValue) => accumulator + currentValue.Quantity, 0)
            : 0;
        let totalProjectItems = state.basket && state.basket.ProjectItems
            ? state.basket.ProjectItems.reduce((accumulator, currentValue) => accumulator + currentValue.Quantity, 0)
            : 0;
        let totalTrayItems = state.basket && state.basket.TrayItems
            ? state.basket.TrayItems.reduce((accumulator, currentValue) => accumulator + currentValue.Quantity, 0)
            : 0;
        let totalCount = totalSiteItems + totalTrayItems + totalProjectItems;
        let type = 1;
        let cartCountElement = document.getElementsByClassName("nav-top-customer-link-with-number-indicator")[0];
        if (!cartCountElement) {
            type = 0;
            cartCountElement = document.getElementsByClassName("nav-top-customer-link-with-number-indicator-empty")[0];
        }
        if (totalCount > 0) {
            cartCountElement.classList.add("nav-top-customer-link-with-number-indicator");
            cartCountElement.classList.remove("nav-top-customer-link-with-number-indicator-empty");
        } else {
            cartCountElement.classList.add("nav-top-customer-link-with-number-indicator-empty");
            cartCountElement.classList.remove("nav-top-customer-link-with-number-indicator");
        }
        cartCountElement.innerHTML = totalCount;
    },
    updateBasketItem(state, { res }) {
        const results = { ...res.data.Data }
        const updateItems = (array) => {
            array && array.forEach((element, index) => {
                let vehicleId = element.VehicleId;
                let selectedSize = element["SampleSizes"].find(({ Value }) => Value === vehicleId);
                if (selectedSize) {
                    array[index]["isVehicleIdMatch"] = true;
                } else {
                    array[index]["isVehicleIdMatch"] = false;
                }
            });
            return array
        }
        results.SiteItems = updateItems(results.SiteItems,);
        results.ProjectItems = updateItems(results.ProjectItems);
        state.basket = results;
    },
    setLoader(state, value) {
        state.loader = value
    },
    setSaveForLaterItems(state, data) {
        const results = {}
        const updateSaveItems = (array) => {
            array && array.forEach((element, index) => {
                let selectedSize = element.SampleSizes.find(({ Selected }) => Selected === true);
                if (selectedSize) {
                    array[index]['SelectedSample'] = selectedSize;
                } else {
                    array[index]["SelectedSample"] = element.SampleSizes[0];
                }
            });
            return array
        }
        results.ProjectItems = updateSaveItems(data.ProjectItems);
        results.SiteItems = updateSaveItems(data.SampleItems);
        state.saveForLater = results;
    },

    setCheckoutTypeProceed(state, value) {
        state.checkoutTypeProceed = value
    },
    setMaxCartLimit(state, result) {
        state.MaxCartLimit = result;
    },
    setFullTypeSizeSamples(state, { result }) {
        state.fullTypeSizeSamples = result;
    },
    setIdeaBookFlag(state, data) {
        state.ideaBookFlag = data;
    }
};

// Actions
const actions = {
    async fetchBasketItem({ commit, }, data) {
        commit("setLoader", true);
        await PatcraftApi.getBasketData(data).then(res => {
            commit("setBasketItem", res.data);
        }).catch(error => {
            console.log(error);
        }).finally(() => {
            commit("setLoader", false);
        });
    },
    async fetchSaveForLaterItems({ commit, dispatch }, payload) {
        let self = this;
        commit("setLoader", true);
        await PatcraftApi.getSaveForLaterBasket(payload).then(res => {
            commit("setSaveForLaterItems", res.data);
            if (payload?.RequestAction && payload?.RequestAction === "remove") {                
                dispatch("notifications/add", {
                    type: "success",
                    title: self._vm.$resourceString["myBasket.Notification.Title.BasketUpdated"],
                    description: self._vm.$resourceString["myBasket.Notification.SavedForLater.Description.Remove"],
                }, { root: true }
                );
            }
        }).catch(error => {
            console.log(error);
        }).finally(() => {
            commit("setLoader", false);
        });
    },
    updateCheckoutTypeProceed({ commit }, value) {
        commit("setCheckoutTypeProceed", value)
    },
    updateMaxCartLimit({ commit, state }, data) {
        commit("setMaxCartLimit", data);
    },
    postBasket({ commit, dispatch, state }, data) {
        let self = this;
        commit("setLoader", true);
        PatcraftApi.postBasket(data.item).then(res => {
            if (data.item.RequestAction === "save") {
                if (data.item.VehicleId === state.basket.LatestIdeaBook.IdeabookVehicleId && data.item.IsIdeaBook) {
                   self._vm.$cookies.set("ideaBook", false, "1m");
                   state.basket.SiteItems = state.basket.SiteItems.filter(({ VehicleId }) => VehicleId !== state.basket.LatestIdeaBook.IdeabookVehicleId);
                   commit("setIdeaBookFlag", false);
                }
                commit("setLoader", false);
                dispatch("fetchSaveForLaterItems", null);
                dispatch("notifications/add", {
                    type: "success",
                    title: self._vm.$resourceString["myBasket.Notification.Title.BasketUpdated"],
                    description: self._vm.$resourceString["myBasket.Notification.SavedForLater.Description.Add"],
                }, { root: true }
                );                
            } else if (data.item.RequestAction === "remove") {
                commit("setLoader", false);
                dispatch("notifications/add", {
                    type: "success",
                    title: self._vm.$resourceString["myBasket.Notification.Title.BasketUpdated"],
                    description: self._vm.$resourceString["myBasket.Notification.Description.Remove"],
                }, { root: true }
                );
            }
        }).catch(error => {
            commit("setLoader", false);
            console.log(error);
        }).finally(() => {
            dispatch("fetchBasketItem", data.basketName);          
        });
    },
    async fetchFullTypeSizeSamples({ commit }, data) {
        let result = []
        await PatcraftApi.getFullTypeSizeSamples().then(res => {
            commit("setFullTypeSizeSamples", { result: res.data });
            result = res.data
        }).catch((error) => {
            console.log(error)
            result = []
        });
        return result
    },
    async addToCart({ dispatch }, data) {
        let self = this;
        await PatcraftApi.addToCart(data).then(function (response) {
            dispatch("addLinkWithIndicator");
            let basketCount = response && response.data ? response.data.basketCount : null;
            dispatch("updateCartCountInHeader", basketCount);
            dispatch("notifications/add", {
                type: "success",
                title: self._vm.$resourceString["myBasket.Notification.Title.BasketUpdated"],
                description: self._vm.$resourceString["myBasket.Notification.AddToCart.Description.Add"]
            }, { root: true });
            if (response && response.data && response.data.error)
                dispatch("notifications/add", {
                    type: "warning",
                    title: self._vm.$resourceString["myBasket.Notification.Title.BasketUpdated"],
                    description: response.data.error
                }, { root: true });
               self._vm.$gtm.addToCartEvent(response?.data, 0);
        }).catch(function (error) {
            if (error?.response.data) {
                dispatch("notifications/add", {
                    type: "error",
                    title: self._vm.$resourceString["common.Notification.Error.Title"],
                    description: error.response.data?.message ? error.response.data.message : error.response.data
                }, { root: true }
                );
            } else {
                dispatch("notifications/add", {
                    type: "error",
                    title: self._vm.$resourceString["common.Notification.Error.Title"],
                    description: self._vm.$resourceString["myBasket.Notification.AddToCart.Description.Error"],
                }, { root: true }
                );
            }
        });
    },

    updateCartCountInHeader({ }, basketCount) {
        let type = 1;
        let cartCountElement = document.getElementsByClassName("nav-top-customer-link-with-number-indicator")[0];
        if (!cartCountElement) {
            type = 0;
            cartCountElement = document.getElementsByClassName("nav-top-customer-link-with-number-indicator-empty")[0];
        }
        if (basketCount > 0) {
            cartCountElement.classList.add("nav-top-customer-link-with-number-indicator");
            cartCountElement.classList.remove("nav-top-customer-link-with-number-indicator-empty");
        } else {
            cartCountElement.classList.add("nav-top-customer-link-with-number-indicator-empty");
            cartCountElement.classList.remove("nav-top-customer-link-with-number-indicator");
        }
        cartCountElement.innerHTML = basketCount;
    },
    addLinkWithIndicator() {
        let basketIcon = document.querySelector("#header .nav-top-secondary-desktop .nav-top-customer-link-with-number-indicator-empty");
        if (!basketIcon) return;
        basketIcon.classList.replace("nav-top-customer-link-with-number-indicator-empty", "nav-top-customer-link-with-number-indicator");
    },
    updateLoader({ commit }, data) {
        commit("setLoader", data);
    },
    async updateIdeaBookFlag({ commit, state, dispatch }, data) {
        if (data === false) {
            let item = state.basket.SiteItems.find(({ VehicleId }) => VehicleId === state.basket.LatestIdeaBook.IdeabookVehicleId);
            if (item && item.IsIdeaBook) {
                item.RequestAction = "remove";
                let removeData = {
                    item: item,
                    basketName: BASKET_SITEITEMS
                };
                dispatch("postBasket", removeData);
            }
            this._vm.$cookies.set("ideaBook", data, "1m");
        }
        commit("setIdeaBookFlag", data);
    },
    // project
    clearBasketItems({ commit }, payload) {
        commit("setLoader", true);
        PatcraftApi.clearBasketItems(payload).then(res => {
           commit("setBasketItem", res.data);
        }).catch(error => {
            console.log(error)
        })
        .finally(() => {
          commit("setLoader", false);
        });
    },
    async checkOutPost({ commit, dispatch, state }, data) {
        const self = this;
        let checkOutStatus = false;
        commit("setLoader", true);
        if (((state.basket.SiteItems.length + state.basket.ProjectItems.length) > state.MaxCartLimit.maxallowedcartitems) || (state.basket.TrayItems.length > state.MaxCartLimit.maxallowedcartitems)) {
          dispatch("notifications/add", {
              type: "error",
              title: self._vm.$resourceString["common.Notification.Error.Title"],
              description: ((state.basket.SiteItems.length + state.basket.ProjectItems.length) > state.MaxCartLimit.maxallowedcartitems && state.basket.SiteItems.length > 0 && state.basket.ProjectItems.length > 0) 
                           ? self._vm.$resourceString["myBasket.MaxAllowedCartitems.ProjectAndSiteItems"]
                           : state.basket.SiteItems.length > 0 || state.basket.ProjectItems.length > 0 
                           ? self._vm.$resourceString["myBasket.MaxAllowedCartitems.DefaultItems"]
                           : self._vm.$resourceString["myBasket.MaxAllowedCartitems.TrayItems"]                    
            },{ root: true }
          );
          checkOutStatus = false
          commit("setLoader", false);
          return;
        }
        if (state.ideaBookFlag) {
          data.declineAddIdeaBook = false;
          data.addIdeaBook = true;
        } else {
          data.declineAddIdeaBook = true;
          data.addIdeaBook = false;
        }
        this._vm.$cookies.set("ideaBook", state.ideaBookFlag, "1m");
        await PatcraftApi.checkOutBasket(data).then(res => {
            commit("setCheckoutTypeProceed", data.checkoutType)
            commit("setLoader", false);
            commit("setBasketItem", (res.data ?? {}));
            checkOutStatus = true
          }).catch((error) => {
            checkOutStatus = false;
            commit("setLoader", false);
            console.log("error", error)
          }).finally(() => {});
          return checkOutStatus;
      },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
